import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'
import { ReactComponent as WhatsappIcon} from 'static/svg/whatsapp.svg'
import { CANCELLATION_CONSTANTS, MODAL_TEXTS } from '../constants'

import * as S from './styles'

interface CancelErrorModalProps {
  onClose: () => void
  patientName: string
  patientPhone: string
  appointmentDate: string
  appointmentTime: string
}

export function CancelErrorModal({
  onClose,
  patientName,
  patientPhone,
  appointmentDate,
  appointmentTime
}: CancelErrorModalProps): JSX.Element {

  const handleWhatsAppClick = () => {
    let formattedPhone = patientPhone.replace(/\D/g, '')
    if (!formattedPhone.startsWith(CANCELLATION_CONSTANTS.BRAZIL_COUNTRY_CODE)) {
      formattedPhone = CANCELLATION_CONSTANTS.BRAZIL_COUNTRY_CODE + formattedPhone
    }

    const whatsappUrl = `${CANCELLATION_CONSTANTS.WHATSAPP_BASE_URL}${formattedPhone}`
    window.open(whatsappUrl, '_blank')
  }

  return (
    <ModalGeneric
      modalTitle={
        <>
          <Typography variant="header4" center weight="bold" color="danger">
            {MODAL_TEXTS.ERROR_TITLE}
          </Typography>
        </>
      }
      modalSubtitle={
        <S.SubTitleContent>
          <Typography variant="content2" center>
            Paciente <strong>{patientName}</strong>
          </Typography>
        </S.SubTitleContent>
      }
      btnText={MODAL_TEXTS.BUTTON_UNDERSTAND}
      btnOnClick={onClose}
      hasButton
      hasCloseButton
    >
      <S.ModalContent>
        <S.AppointmentTime>
          <Typography variant="content2" center>
            {appointmentDate} - {appointmentTime}
          </Typography>
        </S.AppointmentTime>
        <S.Explanation>
          <Typography variant="content2" center>
            Esta regra existe para garantir o compromisso entre paciente e profissional, quanto a programação de agendas. Procure cancelar com antecedência.
          </Typography>
        </S.Explanation>
        <S.AdviceBox>
          <Typography variant="content2">
            Caso você realmente não possa realizar esta consulta, entre em contato com o paciente e o avise, para que ele não entre na sala e fique te esperando.
          </Typography>
          <S.WhatsAppButton onClick={handleWhatsAppClick}>
            <WhatsappIcon color='#1F35B5'/>
            <Typography variant="content2" color="primary" weight='bold'>
              Enviar mensagem por WhatsApp
            </Typography>
          </S.WhatsAppButton>
        </S.AdviceBox>
      </S.ModalContent>
    </ModalGeneric>
  )
}
